// Wizard-mode derivation + the R4 category advance gate, kept dependency-free
// (no workspace imports) so the spec property probes under internal/proptests
// can compile this source directly.

export type RegistrationUsageIntent = 'firm' | 'self' | '';
export type RegistrationAccountMode = 'new' | 'join';

// Self intent is always create-new: the join UI is firm-only, and a stale
// accountType of 'join' left over from a firm session must not exempt a
// self-represented registrant from the category requirement.
export function isCreateNewAccountSubmission(
  usageType: RegistrationUsageIntent,
  accountType: RegistrationAccountMode,
): boolean {
  return usageType === 'self' || accountType === 'new';
}

// R4: a create-new-account submission may not advance past Account Setup with
// no category selected. Join submissions never block on category (they never
// write one). The gate lives here — NOT in isStep1Valid — so the Continue
// button stays clickable and the attempt can surface the validation message.
export function categoryGateBlocksAdvance(
  usageType: RegistrationUsageIntent,
  accountType: RegistrationAccountMode,
  selectedCategory: string,
): boolean {
  return isCreateNewAccountSubmission(usageType, accountType) && selectedCategory === '';
}
